export default __webpack_public_path__ + "static/media/work-2right-1.f9b255a0.png";